const { __ } = wp.i18n;
/**
 * Container block
 *
 * @since 3.2.13
 */
export const metadata = {
  name: __("WC charts", "uipress-pro"),
  moduleName: "uip-woocommerce-analytics-charts",
  description: __("Outputs your choice of order data from woocommerce as a chart", "uipress-lite"),
  group: "storeanalytics",
  icon: "bar_chart",
};
